<div class="body">
    <div class="search-row">
        <mat-form-field class="width">
            <mat-label>Suchbegriff</mat-label>
            <input [(ngModel)]="filter" matInput [matAutocomplete]="productAutoComplete" (keyup.enter)="searchProduct()"
                placeholder="Produktnummer und/oder Produktbezeichnung" />
            <button mat-icon-button matSuffix (click)="$event.stopPropagation()">
                <mat-icon>search</mat-icon>
            </button>
            <mat-autocomplete #productAutoComplete="matAutocomplete" [displayWith]="displayProduct.bind(this)"
                class="custom-autocomplete">
                <div *ngFor="let product of products">
                    <mat-option class="custom-option" *ngIf="matchesProductFilter(product)" [value]="product.productid">
                        <app-shop-product-dropdown-preview [product]="product" (onAdd)="addProduct(product)" [count]="productCartMap[product.productid.toString()]"></app-shop-product-dropdown-preview>
                    </mat-option>
                </div>
            </mat-autocomplete>
        </mat-form-field>
    </div>
    <mat-tab-group (selectedIndexChange)="tabChanged($event)">
        <mat-tab label="Beliebte Artikel">
            <div class="article-row">
                <div class="recently-used">
                    <div *ngFor="let product of mostCommonProducts">
                        <app-product-tile-preview [product]="product" (onAdd)="addProduct(product)" [count]="productCartMap[product.productid.toString()]"></app-product-tile-preview>
                    </div>
                </div>
            </div>
        </mat-tab>
        <mat-tab label="Baumstruktur">
            <div class="tree-content">
                <div class="tree-wrapper">
                    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="tree">
                        <!-- This is the tree node template for leaf nodes -->
                        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
                          <li class="mat-tree-node">
                            <!-- use a disabled button to provide padding for tree leaf -->
                            <button mat-icon-button disabled></button>
                            {{node.productgroupnumber}} 
                            <span class="tree-selectable" (click)="treeGroupSelected(node)">
                                {{node.productgroupname}}
                            </span>
                          </li>
                        </mat-tree-node>
                        <!-- This is the tree node template for expandable nodes -->
                        <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
                          <li>
                            <div class="mat-tree-node">
                              <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name">
                                <mat-icon class="mat-icon-rtl-mirror">
                                  {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
                                </mat-icon>
                              </button>
                              {{node.productgroupnumber}} 
                              <span class="tree-selectable" (click)="treeGroupSelected(node)">
                                {{node.productgroupname}}
                              </span>
                            </div>
                            <ul [class.tree-invisible]="!treeControl.isExpanded(node)">
                              <ng-container matTreeNodeOutlet></ng-container>
                            </ul>
                          </li>
                        </mat-nested-tree-node>
                    </mat-tree>
                </div>
                <div class="group-products">
                    <div *ngFor="let product of treeProducts" class="entry">
                        <app-shop-product-dropdown-preview [product]="product" (onAdd)="addProduct(product)" [count]="productCartMap[product.productid.toString()]"></app-shop-product-dropdown-preview>
                    </div>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
</div>